import React, { Component } from 'react';
import Analytics from 'react-ga';
import SimplePageTemplate from '../SimplePageTemplate';
import image1 from './assets/peavey-speakers.png';
import image2 from './assets/sm58.jpg';
import image3 from './assets/at-wireless.jpg';
import bannerImage from './assets/pro-audio-banner.png';

export default class ProAudioPage extends Component {

  componentDidMount() {

    Analytics.pageview('/audio');
  }

  render() {
    return (
      <SimplePageTemplate location={this.props.location}
                          bannerImage={bannerImage}
                          bannerAlt="Professional audio"
                          image1={image1}
                          image2={image2}
                          image3={image3}
                          imageAlt="Professional audio">
        <p>
          Our sound department has the gear you need to take your show on the road or record!
          Loudspeakers, power amps, microphones, recording interfaces - you'll find them here.
          If you're not sure what you need, we'll help you. By leveraging our experience in
          creating sound systems, you can get your system up and running quickly and affordably.
        </p>
      </SimplePageTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProAudioPage/index.js